import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import {
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    MatIconModule,
    MatListModule,
    MatToolbarModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatCheckboxModule,
    MatChipsModule,
    MatSnackBarModule,
    MatTooltipModule,
    MatAutocompleteModule
} from '@angular/material';
import {FlexLayoutModule} from '@angular/flex-layout';
// HighCharts
import { ChartModule } from 'angular-highcharts';

import { KsNavigationModule } from '../../shared/ks-navigation/ks-navigation.module';
import { WarCustomModule } from '../../shared/war-custom/war-custom.module';

import { DashboardPageComponent } from './components/dashboard-page/dashboard-page.component';
import { TestSeriePageComponent } from './components/test-serie-page/test-serie-page.component';

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule, MatInputModule, MatSelectModule, MatFormFieldModule, MatIconModule, MatListModule, MatToolbarModule, MatProgressBarModule, MatProgressSpinnerModule, MatRadioModule,
        MatCheckboxModule, MatChipsModule, MatSnackBarModule, MatTooltipModule, MatAutocompleteModule,
        FormsModule, ReactiveFormsModule,
        FlexLayoutModule,
        HttpClientModule,
        TranslateModule, // See app.module for loader
        RouterModule,

        KsNavigationModule,
        WarCustomModule,
        ChartModule
    ],
    declarations: [
        DashboardPageComponent,
        TestSeriePageComponent
    ],
    exports: [
        DashboardPageComponent,
        TestSeriePageComponent
    ]
})
export class ReportsModule {
}
